import i18n from '../../../../../../../../config/i18n';
import { formatNumberWithCurrency } from '../../../../../../../../helpers/invoiceHelpers';

export const LINE_ITEMS_COLUMNS = (invoice, language) => [
  {
    key: 'descriptionEn',
    label: 'createInvoice.goods_or_service_description',
    _props: { scope: 'col' },
  },
  {
    key: 'unitPrice',
    label: 'createInvoice.unit_price',
    body: (rowItem) =>
      formatNumberWithCurrency(
        Number(rowItem.unitPrice).toFixed(3),
        invoice.currency,
        language,
      ),
    _props: { scope: 'col' },
  },
  {
    key: 'quantity',
    label: 'createInvoice.quantity',
    _props: { scope: 'col' },
  },
  {
    key: 'discountPercentage',
    label: 'createInvoice.discount_or_rebate_percentage',
    body: (rowItem) => `${rowItem.discountPercentage}%`,
    _props: { scope: 'col' },
  },
  {
    key: 'discountAmount',
    label: 'createInvoice.discount_or_rebate_amount',
    body: (rowItem) =>
      formatNumberWithCurrency(
        Number(rowItem.discountAmount).toFixed(3),
        invoice.currency,
        language,
      ),
    _props: { scope: 'col' },
  },
  {
    key: 'subtotalAmount',
    label: 'createInvoice.net_amount',
    body: (rowItem) =>
      formatNumberWithCurrency(
        Number(rowItem.subtotalAmount).toFixed(3),
        invoice.currency,
        language,
      ),
    _props: { scope: 'col' },
  },
  {
    key: 'vatRate',
    label: 'createInvoice.vat_rate',
    body: (rowItem) => getVatRateText(rowItem.vatRateType, rowItem.vatRate),
    _props: { scope: 'col' },
  },
  {
    key: 'vatAmount',
    label: 'createInvoice.vat_amount',
    body: (rowItem) =>
      formatNumberWithCurrency(
        Number(rowItem.vatAmount).toFixed(3),
        invoice.currency,
        language,
      ),
    _props: { scope: 'col' },
  },
  {
    key: 'totalAmount',
    label: 'createInvoice.total_incl_vat',
    body: (rowItem) =>
      formatNumberWithCurrency(
        Number(rowItem.totalAmount).toFixed(3),
        invoice.currency,
        language,
      ),
    _props: { scope: 'col' },
  },
];

const getVatRateText = (vatRateType, vatRate) => {
  if (vatRateType === 'S') {
    return `${vatRate}%`;
  } else if (vatRateType === 'E') {
    return i18n.t('createInvoice.exempt');
  } else if (vatRateType === 'O') {
    return i18n.t('createInvoice.out_of_scope');
  } else if (vatRateType === 'Z') {
    return '0%';
  }
  return '';
};
